/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal, HelpBlock } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';

import OzComponent from '../lib/OzComponent';
import OzTabs from '../lib/OzTabs';
import { usd, newOrder, isLoggedIn, ss, navTo, mapDispatch, distance, upperFirst, setToken, addUrlParam, getParams } from '../utils/util';
import './ProfileMap.css';
import Wrapper from './Wrapper';
import {
  fetchUser,
  getProfile,
} from '../actions';
import EscapeMap from './partials/EscapeMap';


class ProfileMap extends OzComponent {

  static need = [
    ['profile', getProfile, p => p.username],
  ];

  componentDidMount() {
    // document.getElementById('drift-widget-container').remove();
  }

  render() {
    let profile = this.props.profile;
    let escapes = null;
    if (profile) {
      escapes = profile.allEscapes;
    }
    return (
      <div className="ProfileMap">
        {escapes && <EscapeMap
          escapes={escapes}
          mapSize="full"
        />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    profile: state.get.profile,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    fetchUser,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProfileMap);



/** WEBPACK FOOTER **
 ** ./src/components/ProfileMap.js
 **/